import { DialogTrigger } from "@radix-ui/react-dialog";
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { ChevronRight, X } from "lucide-react";

import logoImage from "@assets/images/qr_guide_logo.png";
import frame1Image from "@assets/images/qr_guide_frame_1.png";
import frame2Image from "@assets/images/qr_guide_frame_2.png";
import frame3Image from "@assets/images/qr_guide_frame_3.png";

type Props = {
  children: React.ReactNode;
};
const QrGuideDialog = ({ children }: Props) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="min-w-content max-w-[375px]" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader className="relative">
          <DialogTitle />

          <DialogClose asChild>
            <X className="absolute right-0 cursor-pointer" />
          </DialogClose>
        </DialogHeader>

        <div className="mt-3 flex flex-col items-center space-y-6">
          <img src={logoImage} alt="넥슨플레이 로고" width={80} height={80} />
          <div className="flex items-center text-sm text-gray-700">
            <p>넥슨플래이앱</p>
            <ChevronRight size={16} className="stroke-gray-600" />
            <p>메뉴탭</p>
            <ChevronRight size={16} className="stroke-gray-600" />
            <p>QR 스캐너</p>
          </div>
          <img src={frame1Image} alt="" width={327} />
          <div className="space-y-3">
            <p className="text-13 text-gray-700">기타</p>
            <img src={frame2Image} alt="" width={327} />
          </div>
          <img src={frame3Image} alt="" width={327} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QrGuideDialog;
